import { render } from "./BADGE_READ.vue?vue&type=template&id=aa80a0f8"
import script from "./BADGE_READ.vue?vue&type=script&lang=js"
export * from "./BADGE_READ.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__